export default __webpack_public_path__ + "static/media/login-icon.70d0d2c8.png";